import { createI18n } from 'vue-i18n'
import en from './en'
import ja from './ja'

const messages = {
    en: en,
    ja: ja
}

const i18n = createI18n({
    locale: 'ja',
    fallbackLocale: 'en',
    messages,
    legacy: false,  // Use Composition API mode
    globalInjection: true  // Enable $t in templates
})

export default i18n